module.exports = __webpack_public_path__ + "img/icon-heart-sprite.fbb5e0b7.svg";